var map = {
	"./en-us.json": 75821,
	"./es-es.json": 22644,
	"./id-id.json": 45101,
	"./jp-jp.json": 71136,
	"./km-kh.json": 32636,
	"./ko-kr.json": 42941,
	"./mn-mn.json": 32751,
	"./ms-my.json": 65532,
	"./th-th.json": 94528,
	"./vi-vn.json": 13860,
	"./zh-cn.json": 94813,
	"./zh-hk.json": 17917,
	"./zh-tw.json": 47742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64142;